import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import TeacherDashboard from "./admindashbrd";
import Dashboard from "./studentdashbrd";
import Sidebar from "./Sidebar";
import TeacherPage from "./stdntreg";
import { Toaster } from 'react-hot-toast';
import AddQuestionsForm from './postQuestion';
import AudioList from './audioList';
import FilterAndDownload from './FilterAndDownload';
import StudentDoubts from './StudentDoubts';
import Analytics from './Analytics';
import UserAccessControl from './UserAccessControl';
import FolderAccessControl from './FolderAccessControl';
import '../styles/app.css';
import toast from 'react-hot-toast';

export default function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState(() => {
    return sessionStorage.getItem('adminCurrentPath') || '/';
  });

  // Save current path to sessionStorage when it changes
  useEffect(() => {
    const path = window.location.pathname;
    if (path) {
      sessionStorage.setItem('adminCurrentPath', path);
      setCurrentPath(path);
    }
  }, [window.location.pathname]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Router>
      <div className="app-wrapper">
        <Sidebar 
          isOpen={isSidebarOpen} 
          onClose={() => setIsSidebarOpen(false)} 
        />
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#333',
              color: '#fff',
              padding: '16px',
              borderRadius: '10px',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
        
        <main className={`main-content ${isSidebarOpen ? 'sidebar-open' : ''}`}>
          <Routes>
            <Route 
              path="/" 
              element={
                <TeacherDashboard 
                  toggleSidebar={toggleSidebar}
                  isSidebarOpen={isSidebarOpen}
                />
              } 
            />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/student-progress" element={<Dashboard />} />
            <Route path="/students" element={<TeacherPage />} />
            <Route path="/user-access" element={<UserAccessControl />} />
            <Route path="/folder-access" element={<FolderAccessControl />} />
            <Route path="/quiz" element={<AddQuestionsForm />} />
            <Route path="/audio" element={<AudioList />} />
            <Route path="/doubts" element={<StudentDoubts />} />
            <Route 
              path="*" 
              element={
                <Navigate 
                  to={currentPath} 
                  replace={true}
                />
              } 
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

// // Success notification
// toast.success('Operation completed successfully!');

// // Error notification
// toast.error('Something went wrong!');

// // Custom notification
// toast('Hello World', {
//   icon: '👋',
//   duration: 4000,
// });
